import React from "react";
import { motion} from "framer-motion";


export default function SliderRight() {
    return (
        <div className="wptb-right-pane">
            <div className="social-box style-square">
                <ul>
                    <motion.div whileHover={{ scale: 1.5 }} whileTap={{ scale: 0.8 }}>
                        <li>
                            <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
                                <i className="bi bi-facebook" style={{color: '#1877F2'}}></i>
                            </a>
                        </li>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.5 }} whileTap={{ scale: 0.8 }}>
                        <li>
                            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer">
                                <i className="bi bi-instagram" style={{color: '#fa7e1e'}}></i>
                            </a>
                        </li>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.5 }} whileTap={{ scale: 0.8 }}>
                        <li>
                            <a href="https://www.youtube.com/" target="_blank" rel="noreferrer">
                                <i className="bi bi-youtube" style={{color: '#FF0000'}}></i>
                            </a>
                        </li>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.5 }} whileTap={{ scale: 0.8 }}>
                        <li>
                            <a href="https://www.twitter.com/" target="_blank" rel="noreferrer">
                                <i className="bi bi-twitter-x" style={{color: '#1DA1F2'}}></i>
                            </a>
                        </li>
                    </motion.div>
                </ul>
            </div>
        </div>
    );
}